export const inputs = [
  {
    id: "firstName",
    label: "First Name",
    placeholder: "Enter first name",
    colSpan: 1,
  },
  {
    id: "lastName",
    label: "Last Name",
    placeholder: "Enter last name",
    colSpan: 1,
  },
  {
    id: "email",
    label: "Business Email",
    placeholder: "Enter business email",
    type: "email",
    colSpan: 2,
  },
  {
    id: "phoneNumber",
    label: "Phone Number",
    placeholder: "Enter phone number",
    type: "tel",
    colSpan: 2,
  },
  {
    id: "company",
    label: "Company",
    placeholder: "Enter company",
    colSpan: 2,
  },
  {
    id: "role",
    label: "Role",
    placeholder: "Select your role",
    type: "select",
    colSpan: 2,
    options: [
      { value: "financing_broker", label: "Financing Broker" },
      { value: "lender", label: "Lender" },
    ],
  },
  {
    id: "website",
    label: "Company Website",
    placeholder: "Enter company website",
    colSpan: 2,
  },
  {
    id: "referrerName",
    label: "Referred By",
    placeholder: "Enter referrer name",
    colSpan: 1,
  },
  {
    id: "referrerEmail",
    label: "Referred Email",
    placeholder: "Enter referrer email",
    colSpan: 1,
  },
];
